/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewFindingSource = {
    Asm: 'asm',
    Firehose: 'firehose',
    External: 'external'
} as const;
export type CRSFSecReviewFindingSource = typeof CRSFSecReviewFindingSource[keyof typeof CRSFSecReviewFindingSource];


export function CRSFSecReviewFindingSourceFromJSON(json: any): CRSFSecReviewFindingSource {
    return CRSFSecReviewFindingSourceFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingSource {
    return json as CRSFSecReviewFindingSource;
}

export function CRSFSecReviewFindingSourceToJSON(value?: CRSFSecReviewFindingSource | null): any {
    return value as any;
}

